(function($){

// ---------- APP START
var App = {

  init: function(){
    $.fn.matchHeight._maintainScroll = true;

    // Init SVG polyfill
    if(typeof(svg4everybody) !== 'undefined') svg4everybody();

    // Init object-fill polyfill
    if(typeof(objectFitImages) !== 'undefined') objectFitImages();

    // Remove focus state when clicking on a button with a mouse
    $(':not(form) button, a').on('click', function(e){
      if(e.clientX && e.clientY)
        $(this).blur();
    });

    if(typeof(Cnil) !== 'undefined') {
      Cnil.init();
    }

    if($('.form-field').length){
      $('.form-field__input')
        .on('focus', function(){ $(this).removeClass('m--error').closest('.form-field').addClass('is-active'); })
        .on('blur', function(){ if($(this).val().length === 0) $(this).closest('.form-field').removeClass('is-active'); })
        .each(function(){
          if($(this).val().length !== 0){
            $(this).closest('.form-field').addClass('is-active');
          }
        });
    }

    if($('.tf-slider-partners').length) App.initSliderPartners();

    window.addEventListener("popstate", function(e) {
      window.location.reload();
    });

    $('body').on('click', '.nf-fu-fileinput-button', function(e) {
      e.preventDefault();
    });
  },

  load: function(){
  },

  initSliderPartners: function() {
    $('.tf-slider-partners').owlCarousel({
      navigation: true,
      slideSpeed: 300,
      paginationSpeed: 400,
      items: 3,
      margin: 5,
      navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"]
    });
  }

};
// ---------- APP END

// Init app
$(document).ready(App.init);
// $(window).load(App.load); // jQuery 2
$(window).on('load', App.load); // jQuery 3
window.App = App;

})(jQuery);

// ---------- MISSING FUNCTIONS
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
// ---------- MISSING FUNCTIONS END
